export default `
varying vec2 vUv;
uniform vec4 uRandom;
uniform float uTime;
uniform float uBeatSpeed;
uniform vec4 uProgress;

float easeOutCubic( float t ) {
    float t1 = t - 1.0;
    return t1 * t1 * t1 + 1.0;
}

float easeInOutCubic( float t ) {
    return t < 0.5 ? 4.0 * t * t * t : ( t - 1.0 ) * ( 2.0 * t - 2.0 ) * ( 2.0 * t - 2.0 ) + 1.0;
}



void main() {
  vUv = uv;

  vec3 pos = position * mix(0.6, 0.8, cos(uTime + uRandom.x * 6.0) * 0.5 + 0.5);

  float scale = fract(uTime * uBeatSpeed - 0.1);
  scale = easeInOutCubic(smoothstep(0.0, 0.25, scale)) * smoothstep(1.0, 0.8, scale);
  scale = mix(0.5, 1.0, scale) * uProgress.x;
  vec4 worldPosition = modelMatrix * vec4(pos * scale, 1.0);
  gl_Position = projectionMatrix * viewMatrix * worldPosition;
}
`
